<!-- @veltra/icons generated sha256:a47a8ff4200103d3 gen:8 source:src/svg/normal/info-circle.svg -->
<script setup lang="ts">
defineOptions({ name: 'InfoCircle' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2m-.6 2.604c0-.33.273-.604.595-.604.332 0 .605.273.605.595a.606.606 0 0 1-.596.605.606.606 0 0 1-.604-.596m.106 2.404v4.484c0 .276.227.508.496.508a.51.51 0 0 0 .504-.508V7.008a.51.51 0 0 0-.497-.508.51.51 0 0 0-.503.508"
    />
  </svg>
</template>
